import { useAuth0 } from '@auth0/auth0-react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Box,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    styled,
    Typography,
} from '@mui/material';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    addPayUser,
    addSubscription,
    removeSubscription,
} from '../../redux/SchoolSlice';
import SubscriptionCard from './SubscriptionCard';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '250px',
    borderRadius: '30px',
}));

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            'color': '#32325d',
            'fontFamily': '"Helvetica Neue", Helvetica, sans-serif',
            'fontSmoothing': 'antialiased',
            'fontSize': '16px',
            '::placeholder': {
                color: '#aab7c4',
            },
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
        },
    },
};

const Subscription = props => {
    const { getAccessTokenSilently } = useAuth0();
    const dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();

    const profile = useSelector(state => state.profile.profile);

    const [subscriptionType, setSubscriptionType] = useState('');
    const [paymentMessage, setPaymentMessage] = useState({
        message: '',
        status: 'idle',
    });
    const [processingPayment, setProcessingPayment] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [addingUser, setAddingUser] = useState(false);
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

    const createPayUser = async () => {
        setAddingUser(true);
        const token = await getAccessTokenSilently();
        await dispatch(addPayUser({ token: token }));
        setAddingUser(false);
    };

    const addSubscriptionReq = type => {
        setSubscriptionType(type);
    };

    // useEffect(() => {
    //     if (
    //         props.school.school.Data.plan !== '' ||
    //         typeof props.school.school.Data.plan !== 'undefined'
    //     ) {
    //         setSubscriptionType(props.school.school.Data.plan);
    //     }
    // }, [props.school.school.Data]);

    const addSubscriptionConfirm = async () => {
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            return;
        }
        setProcessingPayment(true);
        setSubmitDisabled(true);
        try {
            const result = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
                billing_details: {
                    email: profile.Data.Items[0].email,
                    name: props.school.school.Data.displayName,
                },
            });

            if (result.error) {
                console.log(result.error.message);
                setPaymentMessage({
                    message: result.error.message,
                    status: 'failed',
                });
                setProcessingPayment(false);
            } else {
                const token = await getAccessTokenSilently();
                const res = await dispatch(
                    addSubscription({
                        token: token,
                        request: {
                            'payment_method': result.paymentMethod.id,
                            'type': subscriptionType,
                        },
                    })
                );
                // eslint-disable-next-line camelcase
                console.log('status', JSON.stringify(res));
                if (typeof res.error !== 'undefined') {
                    console.log('Failed to add subscription');
                    console.log(res.error);
                    setPaymentMessage({
                        message: 'Unable to process payment. Please try again.',
                        status: 'failed',
                    });
                    setProcessingPayment(false);
                } else {
                    if (res.payload.Message.Success === true) {
                        const { client_secret, status } =
                            res.payload.Message.Data.subscription;

                        if (status === 'requires_action') {
                            stripe
                                .confirmCardPayment(client_secret)
                                .then(function (stripeResult) {
                                    if (stripeResult.error) {
                                        console.log('There was an issue!');
                                        console.log(stripeResult.error);
                                        setPaymentMessage({
                                            message: stripeResult.error,
                                            status: 'failed',
                                        });
                                        // Display error message in your UI.
                                        // The card was declined (i.e. insufficient funds, card has expired, etc)
                                    } else {
                                        setPaymentMessage({
                                            message:
                                                'Successfully added subscription',
                                            status: 'success',
                                        });
                                        // Show a success message to your customer
                                    }
                                })
                                .finally(() => setProcessingPayment(false));
                        } else {
                            setPaymentMessage({
                                message: 'Successfully added subscription',
                                status: 'success',
                            });
                            setProcessingPayment(false);
                            // No additional information was needed
                            // Show a success message to your customer
                        }
                    } else {
                        console.log('Failed to add subscription');
                        setPaymentMessage({
                            message: 'Unable to process payment',
                            status: 'failed',
                        });
                        setProcessingPayment(false);
                    }
                }
            }
        } finally {
            setProcessingPayment(false);
            setSubmitDisabled(false);
        }
    };

    const removeSubscriptionReq = async subscriptionType => {
        const token = await getAccessTokenSilently();
        dispatch(
            removeSubscription({ token: token, request: subscriptionType })
        );
    };

    const getPortalSession = async () => {
        const token = await getAccessTokenSilently();

        const session = await axios.get('/getPortalSession', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        //setDirectCustomerPortal(session.data.Message.Data.url);
        window.location.replace(session.data.Message.Data.url);
        console.log('here is the subscription info', JSON.stringify(session));
    };

    return (
        <Stack>
            {typeof props.school.school.Data.paymentCustomerId ===
                'undefined' && props.schoolAdmin ? (
                <BookingButton
                    onClick={createPayUser}
                    variant="outlined"
                    loading={addingUser}
                    sx={{ width: '300px', margin: '30px 0px' }}
                >
                    Select Subscription
                </BookingButton>
            ) : (
                <Grid
                    container
                    sx={{
                        padding: '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Grid
                        item
                        xs="12"
                        sm="6"
                        md="4"
                        sx={{
                            padding: '20px',
                        }}
                    >
                        <SubscriptionCard
                            selected={props.school.school.Data.plan === 'PAYG'}
                            name="Pay as you Go Subscription"
                            amount={495}
                            interval="booking"
                            subscriptionType={props.school.school.Data.plan}
                            planStatus={props.school.school.Data.planStatus}
                            trialEnd=""
                            subscribeText={
                                subscriptionType === 'PAYG'
                                    ? 'Selected'
                                    : 'Select'
                            }
                            descriptionComponent={
                                <List>
                                    <ListItem disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primary="Pay for only the bookings that are accepted"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Access to all relief teachers"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            }
                            addSubscription={() => addSubscriptionReq('PAYG')}
                            removeSubscription={() =>
                                removeSubscriptionReq('PAYG')
                            }
                        ></SubscriptionCard>
                    </Grid>
                    <Grid
                        item
                        xs="12"
                        sm="6"
                        md="4"
                        sx={{
                            padding: '20px',
                        }}
                    >
                        <SubscriptionCard
                            selected={props.school.school.Data.plan === 'SSP'}
                            name="Standard School Subscription"
                            amount={4995}
                            interval="month"
                            subscriptionType={props.school.school.Data.plan}
                            planStatus={props.school.school.Data.planStatus}
                            trialEnd={props.school.school.Data.trialEnd}
                            subscribeText={
                                subscriptionType === 'SSP'
                                    ? 'Selected'
                                    : 'Trial Now'
                            }
                            descriptionComponent={
                                <List>
                                    <ListItem disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primary="A monthly flat rate with no more to pay"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Unlimited number of bookings"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Access to all relief teachers"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            }
                            addSubscription={() => addSubscriptionReq('SSP')}
                            removeSubscription={() =>
                                removeSubscriptionReq('SSP')
                            }
                        ></SubscriptionCard>
                    </Grid>
                    <Grid
                        item
                        xs="12"
                        sm="6"
                        md="4"
                        sx={{
                            padding: '20px',
                        }}
                    >
                        <SubscriptionCard
                            selected={props.school.school.Data.plan === 'PSP'}
                            name="Premium School Subscription"
                            amount={8995}
                            interval="month"
                            subscriptionType={props.school.school.Data.plan}
                            planStatus={props.school.school.Data.planStatus}
                            trialEnd={props.school.school.Data.trialEnd}
                            subscribeText={
                                subscriptionType === 'PSP'
                                    ? 'Selected'
                                    : 'Select'
                            }
                            descriptionComponent={
                                <List>
                                    <ListItem disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primary="Retain teachers in your own closed network"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="SMS booking notifications"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primary="A monthly flat rate with no more to pay"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Unlimited number of bookings"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Access to all relief teachers"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            }
                            addSubscription={() => addSubscriptionReq('PSP')}
                            removeSubscription={() =>
                                removeSubscriptionReq('PSP')
                            }
                        ></SubscriptionCard>
                    </Grid>
                    <Grid
                        item
                        xs="12"
                        sm="6"
                        md="4"
                        sx={{
                            padding: '20px',
                        }}
                    >
                        <SubscriptionCard
                            selected={props.school.school.Data.plan === 'SS'}
                            name="Simple Subscription"
                            amount={995}
                            interval="month"
                            subscriptionType={props.school.school.Data.plan}
                            planStatus={props.school.school.Data.planStatus}
                            trialEnd={props.school.school.Data.trialEnd}
                            subscribeText={
                                subscriptionType === 'SS'
                                    ? 'Selected'
                                    : 'Select'
                            }
                            descriptionComponent={
                                <List>
                                    <ListItem disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primary="Retain teachers in your own closed network"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="5 free bookings a month (outside of your invited teachers)"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            component="a"
                                            href="#simple-list"
                                        >
                                            <ListItemText
                                                primary="Unlimited booking from your own invited teachers"
                                                sx={{ textAlign: 'center' }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            }
                            addSubscription={() => addSubscriptionReq('SS')}
                            removeSubscription={() =>
                                removeSubscriptionReq('SS')
                            }
                        ></SubscriptionCard>
                    </Grid>
                    {subscriptionType !== '' &&
                        (props.school.school.Data.planStatus === 'Cancelled' ||
                            props.school.school.Data.planStatus === '' ||
                            props.school.school.Data.planStatus ===
                                undefined) && (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={10}
                                lg={6}
                                xl={6}
                                sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'flex',
                                    margin: '20px 0px',
                                }}
                            >
                                <Stack
                                    direction="column"
                                    sx={{
                                        width: '100%',
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{ margin: '8px' }}
                                    >
                                        Enter your card details
                                    </Typography>
                                    <Box
                                        sx={{
                                            border: '1px solid #fff',
                                            borderRadius: '10px',
                                            boxShadow:
                                                '1px 1px 9px -2px rgb(0 0 0 / 20%)',
                                            padding: '20px',
                                            width: '100%',
                                        }}
                                    >
                                        <CardElement
                                            options={CARD_ELEMENT_OPTIONS}
                                        />
                                    </Box>

                                    {paymentMessage.status !== 'success' && (
                                        <BookingButton
                                            variant="outlined"
                                            onClick={addSubscriptionConfirm}
                                            loading={processingPayment}
                                            disabled={submitDisabled}
                                        >
                                            Submit
                                        </BookingButton>
                                    )}
                                    {paymentMessage.status === 'failed' && (
                                        <Typography variant="h6" color="error">
                                            {paymentMessage.message}
                                        </Typography>
                                    )}
                                    {paymentMessage.status === 'success' && (
                                        <Typography variant="h6">
                                            {paymentMessage.message}
                                        </Typography>
                                    )}
                                </Stack>
                            </Grid>
                        )}

                    {props.school.school.Data.planStatus === 'Active' &&
                        (props.school.school.Data.plan === 'SSP' ||
                            props.school.school.Data.plan === 'PAYG' ||
                            props.school.school.Data.plan === 'PSP' ||
                            props.school.school.Data.plan === 'SS') &&
                        props.schoolAdmin && (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <BookingButton
                                    variant="outlined"
                                    onClick={getPortalSession}
                                >
                                    Manage Billing
                                </BookingButton>
                            </Grid>
                        )}
                </Grid>
            )}
        </Stack>
    );
};

export default Subscription;
